module.exports = __webpack_public_path__ + "img/sell.b8c4b679.png";